import styles from './RemoveMemberConfirmDialog.module.scss'

import ConfirmDialog from '@/components/ConfirmDialog'
import FormErrorBanner from '@/components/FormErrorBanner'
import { Spinner } from '@/components/Spinner'

interface RemoveMemberConfirmDialogProps {
  isOpen: boolean
  name: string
  /** Sentence from `getRemovalUsageLine`, shown ahead of the warning. */
  usageLine: string | null
  isUsageLoading?: boolean
  scope: 'team' | 'organization'
  isRemoving: boolean
  error?: string | null
  onConfirm: () => void
  onCancel: () => void
}

// Shared by the Team page and the member detail page so both removal confirmations look the same.
const RemoveMemberConfirmDialog = ({
  isOpen,
  name,
  usageLine,
  isUsageLoading = false,
  scope,
  isRemoving,
  error,
  onConfirm,
  onCancel,
}: RemoveMemberConfirmDialogProps) => (
  <ConfirmDialog
    isOpen={isOpen}
    title={`Remove ${name}?`}
    minWidth={512}
    confirmLabel="Remove"
    confirmType="dark"
    isConfirming={isRemoving}
    onConfirm={onConfirm}
    onCancel={onCancel}
    message={
      <>
        <div className={styles.message}>
          {isUsageLoading ? (
            <Spinner size={16} color="black" />
          ) : (
            `${usageLine ? `${usageLine} ` : ''}They will lose access to your ${scope} immediately. This action cannot be undone.`
          )}
        </div>
        {error && <FormErrorBanner message={error} />}
      </>
    }
  />
)

export default RemoveMemberConfirmDialog
